/* eslint-disable @change/sibling-module-imports */
import type { TranslationKey } from '@change-corgi/core/i18n';
import { Translate } from '@change-corgi/core/react/i18n';
import { Button } from '@change-corgi/design-system-legacy/components/actions';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';
import type { ExportPetitionContentType } from '@change-corgi/middle-end-gql-schema';

type ExportContentType = 'SIGNATURES' | 'COMMENTS';

type Props = Readonly<{
	exportType: ExportContentType;
	data: {
		shouldHideExport: boolean;
		loading: boolean;
		errorMessage: TranslationKey | null;
		successMessage: TranslationKey | null;
	};
	actions: {
		handleExport: (type: ExportPetitionContentType) => Promise<void>;
	};
}>;

export const ExportButton: React.FC<Props> = ({ exportType, data, actions }) => {
	if (data.shouldHideExport) return null;

	return (
		<Box>
			<Box aria-atomic="true" aria-live="polite">
				{!data.loading && !data.errorMessage && (
					<Box data-qa="export-petition-box">
						<Button
							data-testid="starter-dashboard-export-button"
							data-qa="starter-dashboard-export-button"
							type="button"
							aria-label="starter-dashboard-export-button"
							variant="secondary"
							disabled={data.loading}
							loading={data.loading}
							sx={{ pl: '16px !important', pr: '16px !important' }}
							onClick={async () => {
								await actions.handleExport(exportType);
							}}
						>
							<Text>
								<Translate value="corgi.petition.starter_dashboard.shared.export_button.btn_text" />
							</Text>
						</Button>
					</Box>
				)}
			</Box>
		</Box>
	);
};
